import { render, staticRenderFns } from "./AntifoulingCanHelpBlue.vue?vue&type=template&id=790f5cf6"
var script = {}


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports